import React from 'react';

const Privacy = () => {
  return (
    <div className="section-spacing bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8" style={{ color: '#2C2C2C' }}>
            プライバシーポリシー
          </h1>
          
          <div className="space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>個人情報の取り扱いについて</h2>
              <p>
                さくらローカルビジネスサポート（以下、「当事業者」といいます）は、お客様の個人情報を重要な資産と認識し、適切に管理いたします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>1. 収集する個人情報</h2>
              <p className="mb-3">当事業者は、以下の個人情報を取得することがあります。</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>お名前</li>
                <li>メールアドレス</li>
                <li>電話番号</li>
                <li>店舗名・事業者名</li>
                <li>住所</li>
                <li>お問い合わせ内容</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>2. 個人情報の利用目的</h2>
              <p className="mb-3">取得した個人情報は、以下の目的で利用いたします。</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>お問い合わせへの対応</li>
                <li>サービスの提供・契約の履行</li>
                <li>サービスに関する連絡</li>
                <li>新サービスのご案内</li>
                <li>請求書の発行</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>3. 個人情報の第三者提供</h2>
              <p>
                当事業者は、以下の場合を除き、お客様の同意なく第三者に個人情報を開示・提供いたしません。
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-3">
                <li>法令に基づく場合</li>
                <li>人の生命、身体または財産の保護のために必要がある場合</li>
                <li>お客様の同意がある場合</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>4. 個人情報の管理</h2>
              <p>
                当事業者は、個人情報を正確かつ最新の状態に保ち、不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、適切な安全対策を講じます。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>5. Cookieについて</h2>
              <p>
                当サイトでは、より良いサービスを提供するためにCookieを使用することがあります。Cookieはお客様のブラウザ設定で無効化することができますが、一部の機能が利用できなくなる場合があります。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>6. 個人情報の開示・訂正・削除</h2>
              <p>
                お客様ご自身の個人情報について、開示・訂正・削除を希望される場合は、お問い合わせ窓口からご連絡ください。本人確認の上、適切に対応いたします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>7. プライバシーポリシーの変更</h2>
              <p>
                当事業者は、必要に応じて本ポリシーを変更することがあります。変更後のポリシーは、当サイトに掲載した時点から効力を生じます。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>8. お問い合わせ</h2>
              <p>
                個人情報の取り扱いに関するお問い合わせは、以下の連絡先までお願いいたします。
              </p>
              <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                <p className="font-semibold">さくらローカルビジネスサポート</p>
                <p>メール：info@sakura-local.jp</p>
              </div>
            </section>

            <div className="pt-8 border-t">
              <p className="text-sm text-gray-600">制定日：2025年12月1日</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;